/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail200,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail.ts";
import { studentGradeDetailViewModelSchema } from "../studentGradeDetailViewModelSchema.ts";

export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail200Schema =
  z.lazy(
    () => studentGradeDetailViewModelSchema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500>;

export const getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse>;
